import { h, Fragment } from 'preact';

import { FormFullNameControls } from 'src/types/form-config';

import { KycProps } from '../../../constants/kyc';

const ControlCompleteName = props => {
  const controls: FormFullNameControls = props.controls;

  const salutaion = controls[KycProps.SALUTAION];
  const firstname = controls[KycProps.FIRSTNAME];
  const middlename = controls[KycProps.MIDDLE_NAME];
  const lastname = controls[KycProps.LAST_NAME];

  return (
    <div>
      <p>Complete Name</p>
      <div class="row">
        <div
          class="col-sm-12 col-md-2 col-lg-2 col-xl-2"
          key={crypto.randomUUID()}
        >
          <div class="form-floating mb-3 form-group">
            <input
              type={salutaion.type}
              class="form-control input"
              id={salutaion.name}
              name={salutaion.name}
              placeholder={salutaion.placeholder}
              data-validator={salutaion.validator}
              value={salutaion.value}
            />
            <label for="salutation">{salutaion.label}</label>
          </div>
        </div>
        <div
          class="col-sm-12 col-md-4 col-lg-4 col-xl-4"
          key={crypto.randomUUID()}
        >
          <div class="form-floating mb-3 form-group">
            <input
              type={firstname.type}
              class="form-control input"
              id={firstname.name}
              name={firstname.name}
              placeholder={firstname.placeholder}
              data-validator={firstname.validator}
              value={firstname.value}
            />
            <label for="salutation">{firstname.label}</label>
          </div>
        </div>
        <div
          class="col-sm-12 col-md-3 col-lg-3 col-xl-3"
          key={crypto.randomUUID()}
        >
          <div class="form-floating mb-3 form-group">
            <input
              type={middlename.type}
              class="form-control input"
              id={middlename.name}
              name={middlename.name}
              placeholder={middlename.placeholder}
              data-validator={middlename.validator}
              value={middlename.value}
            />
            <label for="salutation">{middlename.label}</label>
          </div>
        </div>
        <div
          class="col-sm-12 col-md-3 col-lg-3 col-xl-3"
          key={crypto.randomUUID()}
        >
          <div class="form-floating mb-3 form-group">
            <input
              type={lastname.type}
              class="form-control input"
              id={lastname.name}
              name={lastname.name}
              placeholder={lastname.placeholder}
              data-validator={lastname.validator}
              value={lastname.value}
            />
            <label for="salutation">{lastname.label}</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ControlCompleteName;
